import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { etb } from '@/lib/money';
import type { GameSummary, Me } from '@/lib/types';
import { ConnectedBar } from '@/components/ConnectedBar';
import { GameList } from '@/components/GameList';

export function Landing() {
    const [me, setMe] = useState<Me | null>(null);
    const [games, setGames] = useState<GameSummary[] | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        const load = (): void => {
            Promise.all([api.get<{ data: Me }>('/me'), api.get<{ data: GameSummary[] }>('/games')])
                .then(([meRes, gamesRes]) => {
                    if (cancelled) return;
                    setMe(meRes.data.data);
                    setGames(gamesRes.data.data);
                })
                .catch((e) => {
                    if (!cancelled) setError(extractMessage(e));
                });
        };
        load();
        const id = window.setInterval(load, 2000);
        return () => {
            cancelled = true;
            window.clearInterval(id);
        };
    }, []);

    const openGames = (games ?? []).filter((g) => g.status === 'open' || g.status === 'active');

    return (
        <div className="lobby w-screen w-lobby">
            <ConnectedBar />

            <div className="w-wallet-card">
                <span className="w-wallet-label">Wallet Balance</span>
                <strong className="w-wallet-amt">{me ? `${etb(me.wallet.balance)} ETB` : '—'}</strong>
            </div>

            {error && <div className="lobby-error">{error}</div>}
            {games === null && !error && <div className="lobby-empty">Loading games…</div>}
            {games && <GameList games={openGames} />}
        </div>
    );
}

function extractMessage(error: unknown): string {
    if (typeof error === 'object' && error !== null && 'response' in error) {
        const res = (error as { response?: { data?: { message?: string } } }).response;
        if (res?.data?.message) return res.data.message;
    }
    return error instanceof Error ? error.message : 'Unknown error';
}
